module.exports = __webpack_public_path__ + "static/media/bender-face-2-red-eyes.74b6944e.png";